import React, { useEffect } from "react";
import { Formik, Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Spinner } from "react-bootstrap";

import { useNavigate } from "react-router-dom";

import "../../styles/auth.css";
import SoilDoctorLogo from "../../assets/Images/SoilDoctorLogo.png";
import LoginImage from "../../assets/Images/LoginImage.png";

import {
  login,
  supportLoginError,
  supportLoginStatus,
  selectIsLoggedIn,
} from "../../store/features/supportSlice";

/* validation */
const loginSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Invalid Email ID")
    .required("Email is required"),
  password: Yup.string().trim().required("Password is required"),
});

const generateClassName = (errors, touched, fieldName) => {
  const hasError = errors[fieldName] && touched[fieldName];
  const isSuccess = touched[fieldName];
  return `form-control mb-2 ${
    hasError ? "border-2 border-danger" : isSuccess && "border-2 border-success"
  }`;
};

const SupportLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoggedIn = useSelector(selectIsLoggedIn);
  const status = useSelector(supportLoginStatus);
  const loginError = useSelector(supportLoginError);

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn, navigate]);

  return (
    <div
      className={`login-container m-0 ${
        window.innerWidth <= 768 ? "py-4" : "py-0"
      }`}
    >
      {/* LEFT CONTENT */}
      <div className="login-left">
        <div className="logo">
          <img src={SoilDoctorLogo} alt="Logo" width="250px" />
        </div>
        <div className="left-content">
          <h1 className="fw-bolder mb-3">Welcome to Soil Doctor!</h1>
          <img src={LoginImage} alt="Background" className="responsive-image" />
          <figure className="w-75">
            <blockquote className="blockquote">
              <h3>
                To forget how to dig the earth and to tend the soil is to forget
                ourselves.
              </h3>
            </blockquote>
            <figcaption className="blockquote-footer">
              <cite title="Source Title">Mohandas K. Gandhi</cite>
            </figcaption>
          </figure>
        </div>
      </div>

      {/* RIGHT CONTENT */}
      <div className="login-right">
        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={loginSchema}
          onSubmit={(values) => dispatch(login(values))}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            setFieldTouched,
          }) => (
            <div className="login-form">
              <Form
                className="form__details"
                onSubmit={handleSubmit}
                onChange={handleChange}
              >
                <h1 className="pt-4 pb-0">Login</h1>

                <Row className="my-4">
                  {/* EMAIL */}
                  <Form.Group as={Col} className="group">
                    <div className="form-floating">
                      <Field
                        type="email"
                        name="email"
                        value={values.email}
                        placeholder="Enter email"
                        className={generateClassName(
                          errors,
                          touched,
                          "email"
                        )}
                        onBlur={() => setFieldTouched("email", true)}
                      />
                      <Form.Label>
                        Email<span className="text-danger">&nbsp;*</span>
                      </Form.Label>
                      {errors.email && touched.email && (
                        <div className="form_errors mb-2">
                          &#9888; {errors.email}
                        </div>
                      )}
                    </div>
                  </Form.Group>

                  {/* PASSWORD */}
                  <Form.Group>
                    <div className="form-floating">
                      <Field
                        type="password"
                        name="password"
                        value={values.password}
                        placeholder="password"
                        className={generateClassName(
                          errors,
                          touched,
                          "password"
                        )}
                        onBlur={() => setFieldTouched("password", true)}
                        disabled={status === "loading"}
                      />
                      <Form.Label>
                        Password<span className="text-danger">&nbsp;*</span>
                      </Form.Label>
                      {errors.password && touched.password && (
                        <div className="form_errors mb-2">
                          &#9888; {errors.password}
                        </div>
                      )}
                    </div>
                  </Form.Group>

                  {/* LOGIN ERROR */}
                  {loginError && (
                    <div className="text-danger mt-2">{loginError}</div>
                  )}

                  {/* SUBMIT */}
                  <Form.Group>
                    <button
                      type="submit"
                      className="w-100 btn btn-dark mt-2 col-md-6"
                      disabled={status === "loading"}
                    >
                      {status === "loading" && (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                      )}
                      Login
                    </button>
                  </Form.Group>
                </Row>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SupportLogin;
